module.exports = __webpack_public_path__ + "img/d-1.baa252e0.png";